import { CUSTOM_ELEMENTS_SCHEMA, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { StatusBar } from '@capacitor/status-bar';
import { MenuComponent } from './core/componente/menu/menu.component';
import { IonicStorageModule } from '@ionic/storage-angular';  // Importando o módulo de Storage

import { IonicSelectableComponent } from 'ionic-selectable';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { Storage } from '@ionic/storage-angular';  // Importando Storage
import { registerLocaleData } from '@angular/common';
import ptPT from '@angular/common/locales/pt-PT'; 
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { AgGridModule } from 'ag-grid-angular';


import { ColumnApiModule, ModuleRegistry, RowAutoHeightModule } from 'ag-grid-community';
import { ClientSideRowModelModule } from 'ag-grid-community';
import { PaginationModule } from 'ag-grid-community';
import { TextFilterModule } from 'ag-grid-community';
import { NumberFilterModule } from 'ag-grid-community';
import { DateFilterModule } from 'ag-grid-community';
import { CustomFilterModule } from 'ag-grid-community';
import { ValidationModule } from 'ag-grid-community';
import { CellStyleModule } from 'ag-grid-community';
import { LocaleModule } from 'ag-grid-community';
import { SafePipe } from './pipes/safe.pipe';
import { RowStyleModule } from 'ag-grid-community';

 

// Importações do AG Grid Enterprise (se você os usa)


ModuleRegistry.registerModules([
  ClientSideRowModelModule,
  PaginationModule,
  TextFilterModule,
  NumberFilterModule,
  DateFilterModule,
  CustomFilterModule,
  CellStyleModule, 
  ValidationModule,
  LocaleModule,
  RowAutoHeightModule,
  ColumnApiModule,
  RowStyleModule   
]);


registerLocaleData(ptPT);
@NgModule({
  declarations: [AppComponent, MenuComponent, SafePipe],
  imports: [
    HttpClientModule,
    IonicSelectableComponent,
    BrowserModule, 
    IonicModule.forRoot(), 
    AppRoutingModule, 
    IonicStorageModule.forRoot({
      name: '__protix_app',
      driverOrder: ['indexeddb', 'localstorage', 'sqlite', 'websql']
    }),
    NgxMaskDirective, 
    NgxMaskPipe,
    NgxDatatableModule,
    AgGridModule,
    
  ],
  providers: [    
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: LOCALE_ID, useValue: 'pt-PT' },
    provideNgxMask(),
    Storage  // Aqui é onde você fornece o Storage corretamente
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]  // Importante se estiver usando Web Components
})
export class AppModule {}
